import type { SearchConfig } from '@eliadmin/core/src/components/header/search-bar/search-config-types';

/** Keep the header's manufacturer results alongside the shared search sections. */
export const SEARCH_CONFIG: SearchConfig = {
  mode: 'drawer',
  sections: ['products', 'categories', 'articles', 'tags', 'manufacturers'],
};
